<template>
  <div class="liucheng">
    <div class="kong"></div>
    <div class="liucheng-div w-1200">
      <el-steps
        :active="0"
        finish-status="success"
        simple
        style="margin-top: 20px"
      >
        <el-step title="填写企业及联系人信息"></el-step>
        <el-step title="填写店铺基础信息"></el-step>
        <el-step title="等待审核"></el-step>
      </el-steps>
      <el-form ref="form" :model="form" label-width="200px">
        <div class="liucheng-div-span">
          <span class="liucheng-div-span-span">联系人信息</span>
        </div>
        <el-form-item label="联系人">
          <el-input v-model="form.shopStoreAuthen.contactPerson"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话">
          <el-input v-model="form.shopStoreAuthen.phone"></el-input>
        </el-form-item>
        <el-form-item label="联系人邮箱">
          <el-input v-model="form.shopStoreAuthen.email"></el-input>
        </el-form-item>
        <el-form-item label="省市县">
          <el-cascader
            :options="options2"
            :show-all-levels="true"
            :props="{ checkStrictly: false }"
            clearable
            ref="cascader"
            leafOnly="false"
            v-model="form.shopStoreAuthen.regionCode2"
            @change="handleChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="form.shopStoreAuthen.address"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="form.shopStoreAuthen.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="form.shopStoreAuthen.idcard"></el-input>
        </el-form-item>
        <el-form-item label="身份证正面">
          <el-upload
            class="upload-image"
            :file-list="fileList"
            :headers="headers"
            :multiple="true"
            :limit="1"
            :on-exceed="headerExceed"
            :action="uploadUrl"
            accept="image/jpeg,image/gif,image/png,image/bmp"
            :on-success="handleAvatarSuccess"
            :before-upload="headerBefore"
          >
            <el-input
              v-model="form.shopStoreAuthen.idcardFrontPhoto"
              type="hidden"
              style="width: 60px"
            />
            <Uimage :src="form.shopStoreAuthen.idcardFrontPhoto" />
          </el-upload>
        </el-form-item>
        <el-form-item label="身份证反面">
          <el-upload
            class="upload-image"
            :file-list="fileList"
            :headers="headers"
            :multiple="true"
            :limit="1"
            :on-exceed="headerExceed"
            :action="uploadUrl"
            accept="image/jpeg,image/gif,image/png,image/bmp"
            :on-success="handleAvatarSuccess2"
            :before-upload="headerBefore"
          >
            <el-input
              v-model="form.shopStoreAuthen.idcardBackPhoto"
              type="hidden"
              style="width: 60px"
            />
            <Uimage :src="form.shopStoreAuthen.idcardBackPhoto" />
          </el-upload>
        </el-form-item>
        <el-form-item label="手持身份证正面照">
          <el-upload
            class="upload-image"
            :file-list="fileList"
            :headers="headers"
            :multiple="true"
            :limit="1"
            :on-exceed="headerExceed"
            :action="uploadUrl"
            accept="image/jpeg,image/gif,image/png,image/bmp"
            :on-success="handleAvatarSuccess3"
            :before-upload="headerBefore"
          >
            <el-input
              v-model="form.shopStoreAuthen.idcardHoldPhoto"
              type="hidden"
              style="width: 60px"
            />
            <Uimage :src="form.shopStoreAuthen.idcardHoldPhoto" />
          </el-upload>
        </el-form-item>
        <div class="liucheng-div-span">
          <span class="liucheng-div-span-span">营业执照信息</span>
        </div>
        <el-form-item label="营业执照注册号">
          <el-input v-model="form.shopStoreCompany.companyName"></el-input>
        </el-form-item>
        <el-form-item label="营业执照所在地">
          <el-cascader
            :options="options2"
            :show-all-levels="true"
            :props="{ checkStrictly: false }"
            clearable
            v-model="form.shopStoreCompany.regionCode2"
            @change="handleChange2"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="营业执照所在详细地址">
          <el-input v-model="form.shopStoreCompany.address"></el-input>
        </el-form-item>
        <el-form-item label="营业期限">
          <el-date-picker
            v-model="form.shopStoreCompany.startDate"
            type="date"
            placeholder="营业期限-开始日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="营业期限">
          <el-date-picker
            v-model="form.shopStoreCompany.endDate"
            type="date"
            placeholder="营业期限-结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="注册资本">
          <el-input v-model="form.shopStoreCompany.registCapital"></el-input>
        </el-form-item>
        <el-form-item label="成立日期">
          <el-date-picker
            v-model="form.shopStoreCompany.setupDate"
            type="date"
            placeholder="成立日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="营业执照证书">
          <el-upload
            class="upload-image"
            :file-list="fileList"
            :headers="headers"
            :multiple="true"
            :limit="1"
            :on-exceed="headerExceed"
            :action="uploadUrl"
            accept="image/jpeg,image/gif,image/png,image/bmp"
            :on-success="handleAvatarSuccess4"
            :before-upload="headerBefore"
          >
            <el-input
              v-model="form.shopStoreCompany.companyCert"
              type="hidden"
              style="width: 60px"
            />
            <Uimage :src="form.shopStoreCompany.companyCert" />
          </el-upload>
        </el-form-item>
        <el-form-item label="经营范围">
          <el-input v-model="form.shopStoreCompany.scopeRange"></el-input>
        </el-form-item>
        <div class="liucheng-div-span">
          <span class="liucheng-div-span-span">税务登记信息</span>
        </div>
        <el-form-item label="税务登记代码">
          <el-input v-model="form.shopStoreCompany.registCode"></el-input>
        </el-form-item>
        <el-form-item label="税务登记证">
          <el-upload
            class="upload-image"
            :file-list="fileList"
            :headers="headers"
            :multiple="true"
            :limit="1"
            :on-exceed="headerExceed"
            :action="uploadUrl"
            accept="image/jpeg,image/gif,image/png,image/bmp"
            :on-success="handleAvatarSuccess5"
            :before-upload="headerBefore"
          >
            <el-input
              v-model="form.shopStoreCompany.registCert"
              type="hidden"
              style="width: 60px"
            />
            <Uimage :src="form.shopStoreCompany.registCert" />
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">下一步</el-button>
          <el-button @click="stepLast">{{ $t('button.Cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { selAreaList, getCategory, shopApplication } from '../../api/ruzhu';
import { baseURL } from '@/utils/request';
export default {
  data() {
    return {
      form: {
        shopStoreAuthen: {
          contactPerson: '',
          phone: '',
          email: '',
          provinceCode: '',
          province: '',
          city: '',
          region: '',
          cityCode: '',
          regionCode: '',
          city: '',
          address: '',
          name: '',
          idcard: '',
          idcardFrontPhoto: '',
          idcardBackPhoto: '',
          idcardHoldPhoto: '',
          regionCode2: '',
        },
        shopStoreCompany: {
          companyName: '',
          companyNo: '',
          provinceCode: '',
          cityCode: '',
          regionCode: '',
          region: '',
          province: '',
          city: '',
          address: '',
          startDate: '',
          endDate: '',
          registCapital: '',
          setupDate: '',
          companyCert: '',
          scopeRange: '',
          registCode: '',
          registCert: '',
          regionCode2: '',
        },
      },

      options2: [], //省市县
      loading: false,
      dialog: false,
      uploadUrl: baseURL + 'f/api/frontCommon/upload',
      imageUrlDefault:
        'data:image/png;base64,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',
      headers: {
        Accept: 'application/json',
        Authorization: localStorage.getItem('Authorization'),
      },
      fileList: [],
      rules: {
        code: [
          {
            required: true,
            message: 'please enter',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    this.form.shopStoreAuthen =
      this.$parent.params['shopStoreAuthen'] || this.form.shopStoreAuthen;
    this.form.shopStoreCompany =
      this.$parent.params['shopStoreCompany'] || this.form.shopStoreCompany;
    this.$nextTick(() => {
      selAreaList().then((data) => {
        this.options2 = data;
      });
    });
  },
  methods: {
    onSubmit() {
      this.$parent.onSubmit(1, this.form);
    },
    stepLast() {
      this.$router.go(-1);
    },
    handleChange(value) {
      this.form.shopStoreAuthen.region = this.$refs[
        'cascader'
      ].getCheckedNodes()[0].label;
      this.form.shopStoreAuthen.provinceCode = value[0];
      this.form.shopStoreAuthen.cityCode = value[0];
      this.form.shopStoreAuthen.regionCode = value[0];
    },
    handleChange2(value) {
      this.form.shopStoreCompany.region = this.$refs[
        'cascader'
      ].getCheckedNodes()[0].label;
      this.form.shopStoreCompany.provinceCode = value[0];
      this.form.shopStoreCompany.cityCode = value[0];
      this.form.shopStoreCompany.regionCode = value[0];
    },
    handleAvatarSuccess2(res, file) {
      this.form.shopStoreAuthen.idcardFrontPhoto = URL.createObjectURL(
        file.raw
      );
    },
    beforeAvatarUpload(file) {},
    headerExceed: function(file, fileList) {
      this.$notify({
        title: '只能上传一个文件，请删除上一个文件再上传。',
        type: 'err',
        duration: 2500,
      });
    },
    headerBefore: function(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        'image/jpg' ||
        'image/webp' ||
        'image/png';
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error({
          message: this.$t('message.shortmessage-011'),
        });
      }
      if (!isLt2M) {
        this.$message.error({
          message: this.$t('message.The_uploaded_image_size_cannot_exceed_10MB'),
        });
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess: function(r, f, l) {
      this.form.shopStoreAuthen.idcardFrontPhoto = r.fileName;
    },
    handleAvatarSuccess2: function(r, f, l) {
      this.form.shopStoreAuthen.idcardBackPhoto = r.fileName;
    },
    handleAvatarSuccess3: function(r, f, l) {
      this.form.shopStoreAuthen.idcardHoldPhoto = r.fileName;
    },
    handleAvatarSuccess4: function(r, f, l) {
      this.form.shopStoreCompany.companyCert = r.fileName;
    },
    handleAvatarSuccess5: function(r, f, l) {
      this.form.shopStoreCompany.registCert = r.fileName;
    },
  },
};
</script>
<style lang="scss" scoped>
.liucheng {
  background-color: #f5f5f5;

  .liucheng-div {
    padding-bottom: 1px;
    background-color: white;
    padding: 20px;
    padding-right: 100px;

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    img {
      width: 180px !important;
    }

    .avatar-uploader-icon:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }

    .el-input {
      width: calc(100% - 200px) !important;
    }

    .el-cascader {
      width: calc(100% - 200px) !important;
    }

    .liucheng-div-span {
      margin-left: 80px;
      display: inline-block;
      position: relative;

      .liucheng-div-span-span {
        line-height: 80px;
        font-size: 21px;
        font-weight: 400;

        &:before {
          content: '';
          position: absolute;
          width: 9px;
          height: 24px;
          background-color: #2659f2;
          top: 0px;
          bottom: 0px;
          left: -20px;
          margin: auto;
        }
      }
    }
  }

  .kong {
    width: 100%;
    height: 25px;
    background: #f5f5f5;
  }
}
</style>
